import { VdsBadgePill } from '@volt/volt-extended-components-react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import ElementList from '@cas/components/tables/cells/element-list/ElementList';
import { FileStatus } from '@customer/store/apis/assetsApi';

const getColour = (
  fileStatus: FileStatus,
): 'danger' | 'healthy' | 'information' | 'neutral' | 'warning' => {
  switch (fileStatus) {
    case FileStatus.Unknown:
    case FileStatus.Failed:
    case FileStatus.MismatchWithConfig:
    case FileStatus.MissingFromDevice:
    case FileStatus.MissingFromConfig:
      return 'danger';

    case FileStatus.Ready:
      return 'healthy';
    case FileStatus.Executing:
    case FileStatus.Downloading:
      return 'warning';

    default:
      return 'neutral';
  }
};

export function FileStatusRenderer({ value }: CustomCellRendererProps): JSX.Element | null {
  const { t } = useTranslation();

  return (
    <ElementList>
      <VdsBadgePill value={t(value)} size="extra-small" statusColor={getColour(value)} />
    </ElementList>
  );
}

export default FileStatusRenderer;
